import { Modal, Select } from "antd";
import { FC, useEffect, useState } from "react";
import { useTranslation } from 'react-i18next';
import { getSteps } from "../../../../api/courses.api";
import useAxios from "../../../../hooks/useAxios";
import { IGetSteps } from "../../../../models/courses.model";
import Button from "../../../Button";
import ErrorResponse from "../../../ErrorResponse";
import Loader from "../../../Loader";

interface IProps {
  visible: boolean;
  onClose: () => void;
  onSubmit: () => void;
  values: number[]|undefined;
  setValues: (values: number[]) => void;
  closeButtonText?: string;
}

const EditLevel: FC<IProps> = ({
  visible,
  onClose,
  onSubmit,
  values,
  setValues,
  closeButtonText,
}) => {
  const { t } = useTranslation();
  const { data: res, isLoading, error, execute } = useAxios<IGetSteps>();
  const [options, setOptions] = useState<any>([]);

  useEffect(() => {
    execute(getSteps());
  }, []);

  useEffect(() => {
    if (res && !isLoading) {
      const _options: any = [];
      res?.data?.forEach((item: any) => {
        const option = (
          <Select.OptGroup label={item.courseName}>
            {item.step.map((subitem: any) => (
              <Select.Option
                key={subitem.courseCode}
                value={subitem.courseCode}
              >
                {subitem.courseName}
              </Select.Option>
            ))}
          </Select.OptGroup>
        );
        _options.push(option);
      });

      setOptions(_options);
    }
  }, [res, isLoading]);

  return (
    <>
      {isLoading ? <Loader /> : null}
      <ErrorResponse error={error} />

      <Modal
        title={t('homepage.survey.title7')}
        visible={visible}
        onCancel={onClose}
        width={750}
        footer={[
          <div className="comm-btn__area justify-content-center">
            <Button
              className="btn-basic pink"
              onClick={onSubmit}
              text={t('common.button.save')}
            />
            <Button
              className="btn-basic gray"
              onClick={onClose}
              text={closeButtonText || t('common.button.cancel')}
            />
          </div>
        ]}
      >

        <div className="comm-bx__between">
          <Select
            className="w-100"
            placeholder={t('common.button.select')}
            mode="multiple"
            value={values}
            onChange={e => setValues(e)}
            virtual={true}
            maxTagCount={8}
          >
            {options}
          </Select>
        </div>
      </Modal>
    </>
  );
}

export default EditLevel;
